import React, {useState, useRef } from 'react';
import {useTheme} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Fab from '@mui/material/Fab';
import CloseIcon from '@mui/icons-material/Close';
import MediaPlayer from './modal/MediaPlayer';
import ThemeFigcaption from './ThemeFigcaption';
import ModalGallery from './modal/ModalGallery';
import ModalIframe from './modal/ModalIframe';
import {ModalZooms} from './modal/ModalZooms';
import ModalImage from './modal/ModalImage';

export function DraggableDialog({modal}) {

    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const modalId = 'modal-' + modal.id;
    const modalRef = useRef(null);
    const modalPaddingY = 156;

    const modalContent = () => {
        
        let elements = null;

        // frameStyle() is a Patch for 1 exception (id 34)
        const frameStyle = () => {
            var frameStyle = {height:"calc(100% - 24px)"};
            if(modal.id === 34) {
                if (theme.breakpoints.up('sm')) {
                frameStyle = {
                    height:"calc(100% - 24px)", padding:"24px", backgroundColor:"#f3f4f6", width:"calc(100% - 124px)", margin:"0 auto"};
                }
            }
            return frameStyle;
        }


        switch(modal.type) {
            case 'gallery':
            elements = <ModalGallery modal={modal} open={open} />
            break;
            case 'iframe':
            elements = <ModalIframe {...modal} />
            break;
            case 'image':
            elements = <ModalImage {...modal}/>
            break;
            case 'zoom':
            elements = <ModalZooms {...modal} />
            break;
            case 'video':
            elements = <MediaPlayer media={modal.content.video} play={open} mediaType="video" className={`absolute bottom-0 right-0 z-50`} width="100%" style={frameStyle()} />
            break;
            default:
            elements = <div {...modal}/>
            break;
        }

        return elements;
    }

    const contentWidth = () => {

        var width = "1100px";

        switch(modal.width) {
            case 'small':
                width = '700px';
                break;     
            case 'medium':
                width = '1150px';
                break;
            case 'large':
                width = '1400px';
                break;
            case 'fullscreen':
                width = '100vw';
                break;
            default:
                width = '1100px';
        }

        return width;
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleMouseOver = (show) => {
        const mouseEl = document.getElementById('theme-mouse');
        if(mouseEl) {
            if(show) {
                mouseEl.classList.remove('opacity-0');
                mouseEl.classList.add('opacity-1');
            } else {
                mouseEl.classList.remove('opacity-1');
                mouseEl.classList.add('opacity-0');
            }
        }
    };

    const percent = (value, num) => {
        return (value * num) / 100;
    }

    var resizedButton = {
        height: percent(modal.button.height, 80),
        width: percent(modal.button.width, 80),
        left: modal.button.left + percent(modal.button.width, 10),
        top: modal.button.top + percent(modal.button.height, 10)
    }

    return (
        <>
        {modal.animatedButton ? 
        <AnimatedButton modal={modal} handleMouseOver={handleMouseOver} handleClickOpen={handleClickOpen} /> 
        :
        <button 
        style={{
            height:resizedButton.height + '%',
            width:resizedButton.width + '%',
            left:resizedButton.left + '%',
            top:resizedButton.top + '%',
            zIndex:modal.button['zIndex'] ? modal.button.zIndex : 2,
            position:"absolute",
            backgroundColor:theme.palette.primary.main,
            opacity:0,
            cursor:'none'
        }} 
        onMouseOver={() => handleMouseOver(true)}
        onMouseOut={() => handleMouseOver(false)}
        onClick={handleClickOpen}>
            <span>0{modal.id}&nbsp;:&nbsp;{modal.content.title}</span>
        </button>}

        <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby={'title-'+modalId}
        disableScrollLock={true}
       // TransitionComponent={Transition}
        keepMounted={true}
        hideBackdrop={true}
        fullScreen={'zoom' && modal.fullScreen === true || 'image' && modal.fullScreen === true  ? true : false}
        fullWidth={true}
        ref={modalRef}
        sx={(theme) => ({
            '& > .MuiDialog-container': {
                backgroundColor: "rgba(0,0,0,0.2)",
                [theme.breakpoints.down('sm')]: {
                    backgroundColor:"#f3f4f6"
                },
            },
            '& > .MuiDialog-container > .MuiPaper-root': {
                backgroundColor: "transparent",
                boxShadow:"none",
                borderRadius:0,
                maxWidth:contentWidth(),
                overflow:"hidden",
                padding:'zoom' && modal.fullScreen === true ? '24px 0' : '0',
            },
            '.MuiDialog-paperFullWidth':{
                padding:0,
                overflow:"hidden"
            },
            [theme.breakpoints.down('sm')]:{
                maxWidth:'100vw',
                width:'100vw',
                '& > .MuiDialog-container > .MuiPaper-root': {
                    maxWidth:'100vw',
                    width:'100vw',
                    height:'100svh',
                    maxHeight: '100svh',
                    margin:0,
                    borderRadius:0,
                },
            }
        })}
        >
            <DialogTitle id={'title-'+modalId} sx={{height:"64px"}}>
                    <span className="hidden truncate text-sm">{modal.content.modalFigcaption && modal.content.modalFigcaption}</span>
            </DialogTitle>
            <Fab sx={{
                position:"absolute",
                top:"8px",
                right:"0",
                height:"36px",
                width:"36px", 
                boxShadow:"unset",
                [theme.breakpoints.down('sm')]:{
                    right:"8px",
                }
                }}
                size="small" color="default" onClick={handleClose}>
                <CloseIcon/>
            </Fab>
            <DialogContent sx={(theme)=> ({
                height:`calc(100svh - ${modalPaddingY}px)`, 
                padding: modal.type !== 'gallery' ? '0 0 24px' : '0',
                alignContent: 'center',
                [theme.breakpoints.down('sm')]:{
                    maxWidth:'100vw',
                    width:'100vw',
                    '& > .MuiDialog-container > .MuiPaper-root': {
                        maxWidth:'100vw',
                        width:'100vw',
                        margin:0
                    },
                }
            })}>  

                {modalContent(modal)}

                {modal.content['audio'] && 
                    <MediaPlayer media={modal.content.audio} play={open} mediaType="audio" className="absolute bottom-0 right-0 z-50" width="0" height="0" />
                }

            </DialogContent>
            {modal.content.modalFigcaption && ThemeFigcaption({figcaptionText:modal.content.modalFigcaption})}
        </Dialog>
        </>
    );
}

function AnimatedButton({ modal, handleClickOpen, handleMouseOver }) {
    const [isHovered, setIsHovered] = useState(false);
    const theme = useTheme();
    const localHandleMouseOver = () => {
        handleMouseOver(true);
        setIsHovered(true);
    }
    const localHandleMouseOut = () => {
        handleMouseOver(false);
        setIsHovered(false);
    }

    const { image, animation, speed } = modal.animatedButton;
    return (
        <>
        {modal.animatedButton.image &&<button 
        style={{
            height: isHovered ? `${modal.animatedButton.height}%` : `${modal.button.height}%`,
            top: isHovered ? `${modal.animatedButton.top}%` : `${modal.button.top}%`,
            width:modal.button.width + '%',
            left:modal.button.left + '%',
            zIndex:modal.button['zIndex'] ? modal.button.zIndex : 2,
            position:"absolute",
            //backgroundColor:theme.palette.primary.main,
            opacity:1,
            cursor:'none',
            transition:`all ${speed}s`,
            overflow:"hidden",
            display:"flex",
            flexDirection:"column",
            justifyContent: animation === "up" ? "flex-start" : "flex-end"
        }} 
        onMouseOver={() => localHandleMouseOver()}
        onMouseOut={() => localHandleMouseOut()}
        onClick={handleClickOpen}>
            <img src={image.src} style={{display:"block",objectFit:"cover"}}/>
        </button>}
        </>
    );
}
